import User from '@/store/models/user/User'

import {
  applyBaseTags, clearSentryUser, setSentryCollection, setSentryUser,
} from './scope'

const AUTH_USER_ID_MUTATION = 'auth/setUserId'
const DEVICE_FIELD_MUTATIONS = new Set([
  'device/setPlatform',
  'device/setOs',
  'device/setBrowser',
  'device/setBrowserVersion',
])
const COLLECTION_ROUTE_PARAM = 'collectionId'

function syncUserFromStore(store) {
  const userId = store.getters['auth/userId']
  if (!userId) {
    clearSentryUser()
    return
  }
  const user = User.query().find(userId)
  setSentryUser({
    id: userId,
    email: user?.email,
    username: user?.username,
  })
}

function syncBaseTagsFromStore(store) {
  applyBaseTags(store.state.device)
}

export function bindSentryToStore(store, router) {
  if (!store) return

  syncUserFromStore(store)
  syncBaseTagsFromStore(store)

  store.subscribe(mutation => {
    if (mutation.type === AUTH_USER_ID_MUTATION) {
      syncUserFromStore(store)
      return
    }
    if (DEVICE_FIELD_MUTATIONS.has(mutation.type)) {
      syncBaseTagsFromStore(store)
    }
  })

  if (router?.afterEach) {
    router.afterEach(to => {
      const collectionId = to?.params?.[COLLECTION_ROUTE_PARAM] ?? null
      setSentryCollection(collectionId)
    })
  }
}
